import React from 'react';
export function PartnersSection() {
  const partners = [{
    name: 'Blaxland Inn',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/BLAXLAND-INN-logo-black-made-smaller.avif',
    link: 'https://www.blaxlandinn.com.au/'
  }, {
    name: 'Pokolbin Cider House',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Cider-Logo-for-Website.avif',
    link: 'https://www.pokolbinciderhouse.com.au/'
  }, {
    name: 'Petersons Wines',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Petersons-Logo_wines-of-distinction-amended.avif',
    link: 'https://www.petersonswines.com.au/'
  }, {
    name: 'Savannah Estate',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/savannah-logo.avif',
    link: 'https://www.savannahestate.com.au/'
  }, {
    name: 'Ben Ean',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Ben-Ean-Logo-Primary-BLK-RGB-scaled.webp',
    link: 'https://www.benean.com.au/'
  }, {
    name: 'Petersons Armidale',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/ARM.avif',
    link: 'https://www.petersonsguesthouse.com.au/'
  }];
  return <section className="bg-white py-16 px-8" data-id="element-150">
      <div className="max-w-7xl mx-auto" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-153" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-154">
            Collaborations
          </div>
          <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-155">
            Our Partners
          </h2>
          <p className="text-lg text-neutral-600" data-id="element-156">
            Visit our local Hunter Valley partner businesses.{' '}
            <em data-id="element-157">For Wine Club Members you will also enjoy discounts!</em>
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-158">
          {partners.map((partner, index) => <a key={index} href={partner.link} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center group" data-id="element-159">
              <img src={partner.imageUrl} alt={partner.name} className="w-full h-24 object-contain grayscale group-hover:grayscale-0 transition-all" data-id="element-160" />
            </a>)}
        </div>
      </div>
    </section>;
}